import mediaVendorService from "../../services/mediavendor";
const getDefaultState = () => {
    return {
        MediaVendor: {
            ID: 0,
            IsCreditCardAccepted: null,
            IsBankingInfoCollected: null,
            CreditCardFiles: [],
            IsDigitalMedia: null,
            IsMediaRepRequest: null,
            CallLetters: null,
            MarketNumbers: null,
            MarketName: null,
            VendorBusinessName: null,
            VendorInvoiceCopyFiles: [],
            IdentificationType: null,
            USTaxID: null,
            Foreign: null,
            SocialSecurityNumber: null,
            IdentificationFiles: [],
            RemittanceAdviceEmail: null,
            EmployeeTitle: null,
            EmployeePhoneNumber: null,
            EmployeeAgency: null,
            AgencyName: null,
            Attestation: null,
            TypeOfProductOrServiceProvidedByVendor: null,
            DollarsAnticipatedToConductAnnuallyByVendor: null,
            VendorFormIncludeACHBankingInfo: null,
            AnyGiftOrCompensationOfferedToYouToPlaceOrder: null,
            CompensationReceived: null,
            EmployeeVendorRelationshipDetails: {
                FormerEmployeeName: null,
                FamilyMemberName: null,
                FriendName: null,
                VendorRelationshipWithAgencyClient: null,
                VendorOfFormerEmployee: null,
                VendorWasFormerEmployeeOfAgency: null,
                VendorHasRelationshipWithAnotherAgencyEmployee: null,
                Other: null,
                MediaVendorRequestID: 0,
                ID: 0,
            },
            EmployeeVendorRelationship: [],
            // MediaTypes: [],
            MediaType: null, //for normal select ion
            EmployeeRelationships: [],
            Requestor: null,
            IsEditDataLoaded: false,
            CompletedForms: [],
            Status: null,
            InfoFromName: null,
            InfoFromTitle: null,
            InfoFromPhone: null,
            ACHPayment: null,
            VendorRemittanceName: null,
            RemittanceCountry: null,
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            RemittanceCity: null,
            RemittanceState: null,
            RemittanceZipCode: null,
            PrintValueSelected: null,
            BankAccountName: null,
            BankAccountNumber: null,
            BankRoutingNumber: null,
            BankName: null,
            BankCountry: null,
            BankAddressLine1: null,
            BankAddressLine2: null,
            BankCity: null,
            BankState: null,
            BankZipCode: null,
            RemittanceEmailAddress: null,
            CreditLimitation: null,
            AreThereConditionsOrLimitations: null,
            BankLetterInvoice: [],
            HasACHPaymentSetup: null,
            HasBankLetterInvoice: null,
            ClientCode: null,
            Entity: null,
            EntityName: null,
            IsVendorWebsiteProvided: null,
            VendorWebsiteLink: null,
            MediaKitAttachments: [],
            IsPaidByWire: null,
            VendorConfirmationEmail: [],
            BankBIC: null,
            BankIBAN: null,
            DigitalMediaType: [],
            MediaTypesWithDigital: []
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    MediaVendor: (state) => {
        return state.MediaVendor;
    },
};

// actions
const actions = {
    async GetFormData(st, id) {
        await mediaVendorService
            .GetFormData(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);

                return res.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    GetDraftFormData(st, id) {
        return mediaVendorService.GetDraftFormData(id, st.rootState.auth.idToken);
    },
    GetRequestWithTaskDetails(st, id) {
        return mediaVendorService.GetRequestWithTaskDetails(
            id,
            st.rootState.auth.idToken
        );
    },
    AddRequest(st, data) {
        return mediaVendorService.AddRequest(data, st.rootState.auth.idToken);
    },
    AddRequestWithFiles(st, data) {
        return mediaVendorService.AddRequestWithFiles(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveRequestLevel1(st, data) {
        return mediaVendorService.ApproveRequestLevel1(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveRequestLevel2(st, data) {
        return mediaVendorService.ApproveRequestLevel2(
            data,
            st.rootState.auth.idToken
        );
    },
    AccountingApprove(st, data) {
        return mediaVendorService.AccountingApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    CFOApprove(st, data) {
        return mediaVendorService.CFOApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    CompleteVendorRequest(st, data) {
        return mediaVendorService.CompleteVendorRequest(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectRequestLevel1(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectLevel1"
        );
    },
    RejectRequestLevel2(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectLevel2"
        );
    },
    RejectVendorValidation(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectVendorValidation"
        );
    },
    AccountingReject(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "AccountingReject"
        );
    },
    CFOReject(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "CFOReject"
        );
    },
    GetRequests(st, options) {
        return mediaVendorService.GetRequests(st.rootState.auth.idToken, options);
    },
    DownloadList(st, data) {
        return mediaVendorService.DownloadList(st.rootState.auth.idToken, data);
    },
    RenderUploadedFiles(st, { id, category }) {
        return mediaVendorService.RenderUploadedFiles(
            st.rootState.auth.idToken,
            id,
            category
        );
    },
    UpdateRequestWithFiles(st, { id, data }) {
        return mediaVendorService.UpdateRequestWithFiles(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetUsers(st, { agencyName, name }) {
        return mediaVendorService.GetUsers(
            st.rootState.auth.idToken,
            agencyName,
            name
        );
    },
    SaveAsDraft(st, data) {
        return mediaVendorService.SaveAsDraft(data, st.rootState.auth.idToken);
    },

    GetAuditFormData(st, id) {
        return mediaVendorService.GetAuditFormData(id, st.rootState.auth.idToken);
    },
    GetWorkflowStates(st, id) {
        return mediaVendorService.GetWorkflowStates(id, st.rootState.auth.idToken);
    },
    GetWorkflowHistoryStates(st, id) {
        return mediaVendorService.GetWorkflowHistoryStates(
            id,
            st.rootState.auth.idToken
        );
    },
    PendingVendorApproveorComplete(st, data) {
        return mediaVendorService.PendingVendorApproveorComplete(
            data,
            st.rootState.auth.idToken
        );
    },
    DownloadUploadTemplate(st, data) {
        return mediaVendorService.DownloadUploadTemplate(
            st.rootState.auth.idToken,
            data
        );
    },
    SaveRequestAsDraft(st, draftRequestId) {
        var DraftObj = {};
        DraftObj.DraftRequestID =
            draftRequestId != null && !isNaN(draftRequestId) ?
            parseInt(draftRequestId) :
            null;
        DraftObj.MediaType = st.getters.MediaVendor.MediaType;
        DraftObj.DigitalMediaType = Array.isArray(st.getters.MediaVendor.DigitalMediaType) && st.getters.MediaVendor.DigitalMediaType.length > 0
            ? st.getters.MediaVendor.DigitalMediaType.join(',') : '';
        DraftObj.CallLetters = st.getters.MediaVendor.CallLetters;
        DraftObj.MarketNumbers = st.getters.MediaVendor.MarketNumbers;
        DraftObj.MarketName = st.getters.MediaVendor.MarketName;
        let VendorInvoiceCopyFiles = st.getters.MediaVendor.VendorInvoiceCopyFiles;
        DraftObj.Files = [];
        if (VendorInvoiceCopyFiles != null && VendorInvoiceCopyFiles.length > 0) {
            VendorInvoiceCopyFiles.forEach(vendorInvoiceCopyFile => {
                DraftObj.Files.push({ Category: `VendorInvoiceCopyFiles`, Name: vendorInvoiceCopyFile.Name || vendorInvoiceCopyFile.name })
            });
        }
        let CompletedForms = st.getters.MediaVendor.CompletedForms;
        if (CompletedForms != null && CompletedForms.length > 0) {
            CompletedForms.forEach(completedForms => {
                DraftObj.Files.push({ Category: `CompletedForms`, Name: completedForms.Name || completedForms.name })
            });
        }
        DraftObj.CreditLimitation = st.getters.MediaVendor.CreditLimitation;
        let VendorConfirmationEmail = st.getters.MediaVendor.VendorConfirmationEmail;
        if (VendorConfirmationEmail != null && VendorConfirmationEmail.length > 0) {
            VendorConfirmationEmail.forEach(vendorConfirmationEmail => {
                DraftObj.Files.push({ Category: `VendorConfirmationEmail`, Name: vendorConfirmationEmail.Name || vendorConfirmationEmail.name })
            });
        }
        let CreditCardFiles = st.getters.MediaVendor.CreditCardFiles;
        if (CreditCardFiles != null && CreditCardFiles.length > 0) {
            CreditCardFiles.forEach(creditCardFiles => {
                DraftObj.Files.push({ Category: `CreditCardFiles`, Name: creditCardFiles.Name || creditCardFiles.name })
            });
        }
        DraftObj.BankName = st.getters.MediaVendor.BankName;
        DraftObj.BankCountry = st.getters.MediaVendor.BankCountry;
        DraftObj.BankAddressLine1 = st.getters.MediaVendor.BankAddressLine1;
        DraftObj.BankAddressLine2 = st.getters.MediaVendor.BankAddressLine2;
        DraftObj.BankCity = st.getters.MediaVendor.BankCity;
        DraftObj.BankState = st.getters.MediaVendor.BankState;
        DraftObj.BankZipCode = st.getters.MediaVendor.BankZipCode;
        DraftObj.BankAccountName = st.getters.MediaVendor.BankAccountName;
        DraftObj.BankAccountNumber = st.getters.MediaVendor.BankAccountNumber;
        DraftObj.BankRoutingNumber = st.getters.MediaVendor.BankRoutingNumber;
        DraftObj.BankIBAN = st.getters.MediaVendor.BankIBAN;
        DraftObj.BankBIC = st.getters.MediaVendor.BankBIC;
        DraftObj.RemittanceEmailAddress = st.getters.MediaVendor.RemittanceEmailAddress;
        let BankLetterInvoiceFiles = st.getters.MediaVendor.BankLetterInvoice;
        if (BankLetterInvoiceFiles != null && BankLetterInvoiceFiles.length > 0) {
            BankLetterInvoiceFiles.forEach(bankLetterInvoiceFiles => {
                DraftObj.Files.push({ Category: `BankLetterInvoice`, Name: bankLetterInvoiceFiles.Name || bankLetterInvoiceFiles.name })
            });
        }
        DraftObj.VendorBusinessName = st.getters.MediaVendor.VendorBusinessName;
        DraftObj.IdentificationType = st.getters.MediaVendor.IdentificationType;
        DraftObj.USTaxID = st.getters.MediaVendor.USTaxID;
        DraftObj.Foreign = st.getters.MediaVendor.Foreign;
        DraftObj.SocialSecurityNumber = st.getters.MediaVendor.SocialSecurityNumber;
        let IdentificationFiles = st.getters.MediaVendor.IdentificationFiles;
        if (IdentificationFiles != null && IdentificationFiles.length > 0) {
            IdentificationFiles.forEach(identificationFiles => {
                DraftObj.Files.push({ Category: `IdentificationFiles`, Name: identificationFiles.Name || identificationFiles.name })
            });
        }
        DraftObj.VendorWebsiteLink = st.getters.MediaVendor.VendorWebsiteLink;
        let MediaKitAttachments = st.getters.MediaVendor.MediaKitAttachments;
        if (MediaKitAttachments != null && MediaKitAttachments.length > 0) {
            MediaKitAttachments.forEach(mediaKitAttachments => {
                DraftObj.Files.push({ Category: `MediaKitAttachments`, Name: mediaKitAttachments.Name || mediaKitAttachments.name })
            });
        }
        DraftObj.VendorRemittanceName = st.getters.MediaVendor.VendorRemittanceName;
        DraftObj.RemittanceCountry = st.getters.MediaVendor.RemittanceCountry;
        DraftObj.StreetAddressLine1 = st.getters.MediaVendor.StreetAddressLine1;
        DraftObj.StreetAddressLine2 = st.getters.MediaVendor.StreetAddressLine2;
        DraftObj.RemittanceCity = st.getters.MediaVendor.RemittanceCity;
        DraftObj.RemittanceState = st.getters.MediaVendor.RemittanceState;
        DraftObj.RemittanceZipCode = st.getters.MediaVendor.RemittanceZipCode;
        DraftObj.RemittanceAdviceEmail = st.getters.MediaVendor.RemittanceAdviceEmail;
        DraftObj.InfoFromName = st.getters.MediaVendor.InfoFromName;
        DraftObj.InfoFromTitle = st.getters.MediaVendor.InfoFromTitle;
        DraftObj.InfoFromPhone = st.getters.MediaVendor.InfoFromPhone;
        DraftObj.EmployeePhoneNumber = st.getters.MediaVendor.EmployeePhoneNumber;
        DraftObj.Entity = st.getters.MediaVendor.Entity;
        DraftObj.EmployeeAgency = st.getters.MediaVendor.EmployeeAgency;
        DraftObj.AgencyName = st.getters.MediaVendor.AgencyName;
        DraftObj.ClientCode = st.getters.MediaVendor.ClientCode;
        DraftObj.EmployeeVendorRelationship =
            (st.getters.MediaVendor.EmployeeVendorRelationship || []).map(name => ({
                ID: 0,
                RelationshipName: name
            }));
        DraftObj.EmployeeVendorRelationshipDetails = st.getters.MediaVendor.EmployeeVendorRelationshipDetails;
        DraftObj.EmployeeVendorRelationshipDetails.ID = 0;
        DraftObj.CompensationReceived = st.getters.MediaVendor.CompensationReceived;
        const draftFieldsToConvert = [
            "IsMediaRepRequest",
            "IsDigitalMedia",
            "IsPaidByWire",
            "IsCreditCardAccepted",
            "AreThereConditionsOrLimitations",
            "HasACHPaymentSetup",
            "HasBankLetterInvoice",
            "ACHPayment",
            "IsBankingInfoCollected",
            "IsVendorWebsiteProvided",
            "AnyGiftOrCompensationOfferedToYouToPlaceOrder",
        ];
        draftFieldsToConvert.forEach(field => {
            DraftObj[field] = st.getters.MediaVendor[field];
            if (st.getters.MediaVendor[field] === "true") {
                DraftObj[field] = true;
            } else if (st.getters.MediaVendor[field] === "false") {
                DraftObj[field] = false;
            } else {
                DraftObj[field] = null;
            }
        });
        let formData = new FormData();
        formData.append("request", JSON.stringify(DraftObj));

        for (let i = 0; i < VendorInvoiceCopyFiles.length; i++) {
            let file = VendorInvoiceCopyFiles[i];
            formData.append(`VendorInvoiceCopyFiles`, file.file);
        }
        for (let j = 0; j < CompletedForms.length; j++) {
            let file = CompletedForms[j];
            formData.append(`CompletedForms`, file.file);
        }
        for (let l = 0; l < VendorConfirmationEmail.length; l++) {
            let file = VendorConfirmationEmail[l];
            formData.append(`VendorConfirmationEmail`, file.file);
        }
        for (let m = 0; m < CreditCardFiles.length; m++) {
            let file = CreditCardFiles[m];
            formData.append(`CreditCardFiles`, file.file);
        }
        if (BankLetterInvoiceFiles != null && BankLetterInvoiceFiles.length > 0) {
            for (let n = 0; n < BankLetterInvoiceFiles.length; n++) {
                let file = BankLetterInvoiceFiles[n];
                formData.append(`BankLetterInvoice`, file.file);
            }
        }
        for (let o = 0; o < IdentificationFiles.length; o++) {
            let file = IdentificationFiles[o];
            formData.append(`IdentificationFiles`, file.file);
        }
        for (let p = 0; p < MediaKitAttachments.length; p++) {
            let file = MediaKitAttachments[p];
            formData.append(`MediaKitAttachments`, file.file);
        }
        return mediaVendorService.SaveRequestAsDraft(st.rootState.auth.idToken, formData);
    },
    GetDraftRequest(st, id) {
        mediaVendorService
            .GetDraftRequest(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((error) => {
                return error;
            });
    },
    DeleteDraft(st, id) {
        return mediaVendorService.DeleteDraft(st.rootState.auth.idToken, id);
    },

};

function GetFilesCategory() {
    return [
        "CreditCardFiles",
        "VendorInvoiceCopyFiles",
        "IdentificationFiles",
        "CompletedForms",
        "BankLetterInvoice",
        "MediaKitAttachments",
        "VendorConfirmationEmail",
    ];
}
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
    loadVendorData(state, data) {
        Object.assign(state.MediaVendor, data);
        state.MediaVendor.Status = data.Status;
        state.MediaVendor.EmployeePhoneNumber = data.EmployeePhoneNumber;
        state.MediaVendor.Entity = data.Entity;
        state.MediaVendor.EmployeeAgency = data.EmployeeAgency;
        state.MediaVendor.AgencyName = data.AgencyName;
        state.MediaVendor.InfoFromPhone = data.InfoFromPhone;
        if (typeof data.DigitalMediaType === "string") {
            const arr = data.DigitalMediaType.split(",").map(s => s.trim()).filter(Boolean);
            if (arr.length === 1) {
                state.MediaVendor.DigitalMediaType = data.DigitalMediaType.split(",");
            } else {
                state.MediaVendor.DigitalMediaType = data.DigitalMediaType ?
                    data.DigitalMediaType.split(",").map(s => s.trim()) : [];
            }
        }
        const fieldsToConvert = [
            "IsVendorWebsiteProvided",
            "IsPaidByWire",
            "IsCreditCardAccepted",
            "AreThereConditionsOrLimitations",
            "HasACHPaymentSetup",
            "HasBankLetterInvoice",
            "ACHPayment",
            "IsBankingInfoCollected",
            "AnyGiftOrCompensationOfferedToYouToPlaceOrder",
            "IsMediaRepRequest",
            "IsDigitalMedia",
        ];
        fieldsToConvert.forEach(field => {
            if (data[field] === true) {
                state.MediaVendor[field] = "true";
            } else if (data[field] === false) {
                state.MediaVendor[field] = "false";
            } else {
                state.MediaVendor[field] = null;
            }
        });
        state.MediaVendor.EmployeeVendorRelationship = [];
        if (data.EmployeeVendorRelationship != null) {
            data.EmployeeVendorRelationship.forEach((val) => {
                state.MediaVendor.EmployeeVendorRelationship.push(val.RelationshipName);
            });
        }
    },
    loadVendorFiles(state, data) {
        if (data.Files.length > 0) {
            GetFilesCategory().forEach((file) => {
                if (typeof file == "undefined" || file == null) {
                    return;
                } else {
                    let files = data.Files.filter((catFile) => {
                        return catFile.Category == file;
                    });
                    if (files.length > 0) {
                        files.forEach((originalFile) => {
                            state.MediaVendor[file].push(originalFile);
                        });
                    }
                }
            });
        }
        state.MediaVendor.IsEditDataLoaded = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};